"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    checkTccProxyFlag: ()=>checkTccProxyFlag,
    allTccProxyFlagQueries: ()=>allTccProxyFlagQueries,
    libHasQuery: ()=>libHasQuery,
    libInitialQuery: ()=>libInitialQuery,
    libQueryConfig: ()=>libQueryConfig,
    getTccProxyFlagValues: ()=>getTccProxyFlagValues
});
const external_comon_js_namespaceObject = require("./comon.js");
const libQueryConfig = (0, external_comon_js_namespaceObject.keyValueMatch)({
    'x-tcc-proxy-flag': 'x-tcc-proxy-flag',
    'x-bcgw-log': 'x-bcgw-log',
    'skip-remove-jwt-ticket': 'skip-remove-jwt-ticket',
    jwt_ticket: 'jwt_ticket'
});
const libInitialQuery = (()=>{
    try {
        var _location;
        return new URLSearchParams('string' == typeof (null == (_location = location) ? void 0 : _location.search) ? location.search : void 0);
    } catch (error) {
        return new URLSearchParams();
    }
})();
const getTccProxyFlagValues = (search)=>{
    if (!search) return [];
    const searchParams = 'string' == typeof search ? new URLSearchParams(search) : search;
    const allValues = searchParams.getAll(libQueryConfig['x-tcc-proxy-flag']);
    const result = [];
    return result.concat(...allValues.map((value)=>value.split(',')));
};
const allTccProxyFlagQueries = getTccProxyFlagValues(libInitialQuery);
const checkTccProxyFlag = (method, key)=>allTccProxyFlagQueries.includes(`${method}-${key}`);
const libHasQuery = (key)=>libInitialQuery.has(key);
exports.allTccProxyFlagQueries = __webpack_exports__.allTccProxyFlagQueries;
exports.checkTccProxyFlag = __webpack_exports__.checkTccProxyFlag;
exports.getTccProxyFlagValues = __webpack_exports__.getTccProxyFlagValues;
exports.libHasQuery = __webpack_exports__.libHasQuery;
exports.libInitialQuery = __webpack_exports__.libInitialQuery;
exports.libQueryConfig = __webpack_exports__.libQueryConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "allTccProxyFlagQueries",
    "checkTccProxyFlag",
    "getTccProxyFlagValues",
    "libHasQuery",
    "libInitialQuery",
    "libQueryConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
